<template>
    <div>
        <slot name="header"
            :tickets="tickets"
            :formNuevoTicket="formNuevoTicket"
            :itemClick="itemClick"
            :contactoClick="contactoClick"
            :ticketSelected="ticketSelected"
            :responder="responder"
            :formResponder="formResponder"
            :nuevoTicket="nuevoTicket"
            :esNuevo="esNuevo"
            :mostrarInfo="mostrarInfo"
            :cerrar="cerrar"
            :total="total"
            :cerrado="cerrado"
            :abierto="abierto"
            :admin="admin"
            :reasignar="reasignar"
            :contactos="contactos"
            :modalContacto="modalContacto"
            :cerrarContacto="cerrarContacto"
            :atenderContacto="atenderContacto"
            :regresarContacto="regresarContacto">
        </slot>
    </div>
</template>

<script>
import Axios from 'axios';

export default {
    data() { return {
        tickets: [],
        contactos: [],
        ticketSelected: {},
        formNuevoTicket: {},
        formResponder: {},
        esNuevo: false,
        mostrarInfo: true,
        admin: false,
        total: null,
        abierto: null,
        cerrado: null,
        adjunto: null,
        modalContacto: {},
        contactoIndex: null,
    }},
    mounted() {
        const vm = this;
        const nuevoTicketForm = $('#respuestaForm');
        const selectEstado = $('#selectEstado');
        const fileInput = $('#fileInput');

        nuevoTicketForm.submit(function(event) {
            event.preventDefault();
            vm.responder();
        });

        fileInput.on('change', function(e) {
            const formData = new FormData();
            formData.append('adjunto', e.target.files[0])
            vm.adjunto = formData;
            console.log('adjunto:', vm.adjunto);
        });

        selectEstado.on('change', function(e) {
            console.log('cambié');
            console.log(selectEstado.val());
            vm.leetTickets(selectEstado.val());
        });

        vm.leetTickets('1');
    },
    methods: {
        leetTickets(opcion) {
            axios.get('soporte/listado/'+opcion).then(res => {
                this.tickets = res.data.data;
                this.contactos = res.data.contactos;
                this.total = res.data.total;
                this.abierto = res.data.abierto;
                this.cerrado = res.data.cerrado;
                this.admin = res.data.admin;
            }).catch(e => {
                console.log(e);
            });
        },
        crearNuevoTicket() {
            axios.post('soporte/nuevoTicket', this.formNuevoTicket).then(res => {
                console.log(res);
            }).catch(e => {
                console.log(e);
            });
        },
        itemClick(id) {
            this.mostrarInfo = false;
            this.esNuevo = false;
            this.formResponder = {
                'ticket_id': id,
            }
            axios.get('soporte/mensajes/'+id).then(res => {
                const index = this.tickets.findIndex(a => a.id == id);
                this.ticketSelected = this.tickets[index];
                this.ticketSelected.mensajes = res.data;
            }).catch(e => {
                console.log(e);
            });        
        },
        contactoClick(contacto, index) {
            this.modalContacto = contacto;
            this.contactoIndex = index;
            $('#modalContacto').modal('show');
        },
        responder() {
            if(this.esNuevo) {
                axios.post('soporte/nuevoTicket', this.formResponder).then(res => {
                    this.tickets.push(res.data.data);
                    this.ticketSelected = res.data.data;
                    if(this.adjunto) {
                        this.adjuntar(res.data.mensaje_id);
                    }
                    this.formResponder = {};
                    this.esNuevo = false;
                }).catch(e => {
                    console.log(e);
                });
            } else {
                axios.post('soporte/responder', this.formResponder).then(res => {
                    this.ticketSelected.mensajes.push(res.data.data);
                    if(this.adjunto) {
                        this.adjuntar(res.data.mensaje_id);
                    }
                    this.formResponder.descripcion = '';
                    
                    if(res.data.estado) {
                        const index = this.tickets.findIndex(a => a.id == this.ticketSelected.id);
                        this.tickets[index].estado = res.data.estado; 
                    }
                }).catch(e => {
                    console.log(e);
                });
            }   
        },
        adjuntar(mensaje_id) {
            axios.post('soporte/adjuntar/'+mensaje_id, this.adjunto, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(res => {
                console.log('se adjuntó ese rollo', res.data);
                const index = this.ticketSelected.mensajes.findIndex(a => a.id == mensaje_id);
                this.ticketSelected.mensajes[index].adjunto = res.data.nombrearchivo;
                console.log(index, mensaje_id, this.ticketSelected.mensajes[index]);
                this.adjunto = null;
            }).catch(e => {
                console.log('error', e);
            });
        },
        nuevoTicket() {
            this.ticketSelected = {
                asunto: 'Escribir nuevo ticket'
            };
            this.formResponder = {};
            this.esNuevo = true;
            this.mostrarInfo = false;
        },
        cerrar() {
            axios.post('soporte/cerrar/'+this.ticketSelected.id).then(res => {
                if(!res.data.error) {
                    const index = this.tickets.findIndex(a => a.id == this.ticketSelected.id);
                    this.tickets[index].estado = 'cerrado'; 
                }
            }).catch(e => {
                console.log(e);
            });
        },
        reasignar() {
            axios.post('soporte/reasignar/'+this.ticketSelected.id).then(res => {
                if(!res.data.error) {
                    const index = this.tickets.findIndex(a => a.id == this.ticketSelected.id);
                    this.tickets.splice(index, 1);
                    toastr["success"]('El ticket ha sido reasignado al siguiente nivel', "Éxito");
                }
            }).catch(e => {
                console.log(e);
            });
        },
        regresarContacto() {
            $('#modalContacto').modal('hide');
            this.contactoIndex = null;
            this.modalContacto = {};
        },
        atenderContacto() {
            axios.post('contacto/atenderContacto', this.modalContacto).then(res => {
                this.contactos[this.contactoIndex].estado = res.data.estado;
                this.contactos[this.contactoIndex].responsable = res.data.responsable;
                toastr["success"]('El ticket ha sido asignado correctamente', "Éxito");
            }).catch(e => {
                console.log(e);
            });
            $('#modalContacto').modal('hide');
            this.contactoIndex = null;
            this.modalContacto = {};
        },
        cerrarContacto() {
            axios.post('contacto/cerrarContacto', this.modalContacto).then(res => {
                this.contactos[this.contactoIndex].estado = 'atendido';
                toastr["success"]('El ticket ha sido cerrado correctamente', "Éxito");
            }).catch(e => {
                console.log(e);
            });
            $('#modalContacto').modal('hide');
            this.contactoIndex = null;
            this.modalContacto = {};
        },
    }
}
</script>